"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import "./Auto-bewerten.css";
import { TopSection } from "./sections/TopSection";
import { ValueTrackSell } from "./sections/ValueTrackSell";
import { fragenDreiData, fragenEinsData, fragenZweiData } from "./data";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";
import Fragen2 from "../../assets/auto-bewerten/faq-wertsteigerung-bewertung.avif";
import AutoBannerPreisVorschlag from "../../assets/auto-bewerten/auto-bewertung-preis-polo.webp";
import AutoBannerPreisChart from "../../assets/auto-bewerten/auto-bewerten-preis-verlauf.avif";
import AutoBannerAlert from "../../assets/auto-bewerten/auto-bewerten-monatliche-benachrichtigung.avif";

// Die text- und linktragenden Bloecke werden SERVERSEITIG gerendert (dynamic
// OHNE die SSR-Abschaltung, Playbook 2.6 / KEYWORD-PLAN Cluster C): bis hierher
// standen der gesamte Erklaerinhalt, alle 26 FAQ-Eintraege aus data.js und die
// sechs Ratgeber-Kacheln in KEINEM Server-HTML — die Seite lieferte Bing,
// GPTBot und ClaudeBot nur 106 Woerter und drei h2 aus dem Funnel-Kopf.
// Code-Splitting bleibt erhalten: `dynamic` erzeugt auch ohne die
// SSR-Abschaltung weiterhin einen eigenen Chunk.
const BildTextInfo = dynamic(() =>
  import("../../components/BildTextInfo/BildTextInfo")
);
const CarValueBoxes = dynamic(() =>
  import("./sections/CarValueBoxes").then((m) => m.CarValueBoxes)
);
const WertverlustVerfolgen = dynamic(() =>
  import("./sections/WertverlustVerfolgen").then((m) => m.WertverlustVerfolgen)
);
const HäufigeFragen = dynamic(() =>
  import("@/common/HäufigeFragen").then((m) => m.HäufigeFragen)
);
const Ratgeber = dynamic(() => import("@/components/Ratgeber/Ratgeber"));

// Client-only bleiben nur die beiden Bloecke des Anmelde-Schritts
// (Auth-Bindung; sie rendern erst ab Schritt 12 und nie im ersten Server-HTML).
const Banner = dynamic(() => import("@/common/Banner").then((m) => m.Banner), {
  ssr: false,
});

const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function Autobewerten() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);

  return (
    <div className="home-container">
      <TopSection
        title={
          <>
            Gratis Auto <br /> Bewerten
          </>
        }
        smallTitle="Fahrzeugwert-Überwachungstool"
        description={
          <>
            Verfolge den aktuellen Wert und <br />
            verkaufe dein Fahrzeug zum besten Zeitpunkt
          </>
        }
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-bewerten"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <ValueTrackSell
              titleOne="Bewerten"
              fontSize="36px"
              textOne="Erhalte eine sofortige, kostenlose Autobewertung"
              titleTwo="Verfolgen"
              textTwo="Erhalte monatliche Updates zur Wertentwicklung"
              titleThree="Verkaufen"
              textThree="Verkaufe dein Auto zum besten Zeitpunkt"
            />
            <div className="ab-below-fold">
                <div className="Banner-sections">
                  <BildTextInfo
                    image={AutoBannerPreisVorschlag}
                    fontSize="38px"
                    title="Genaue Echtzeit-Bewertungen"
                    text="Die smarte Bewertungstechnologie von Autoeinfachlos nutzt aktuelle
      Daten aus dem österreichischen Automarkt und liefert dir eine
      objektive Fahrzeugbewertung basierend auf Alter, Marke, Modell,
      Kilometerstand und dem Zustand deines Fahrzeugs."
                    alt="Auto Bewertung eines Volkswagen Polo mit geschätztem Preis. Auto bewerten leicht gemacht."
                    addPTag
                  />
                  <BildTextInfo
                    image={AutoBannerPreisChart}
                    revert
                    fontSize="38px"
                    title="Transparente Fahrzeug&shy;bewertung"
                    text="Unser Ziel ist es, dir eine transparente und marktgerechte Bewertung zu liefern, die den tatsächlichen Marktwert deines Autos widerspiegelt. So weißt du genau, was dein Auto wert ist, und kannst es zu optimalen Konditionen verkaufen."
                    alt="Auto bewerten: Fahrzeugbewertung mit einem aktuellen Wert und einer Preisentwicklung über 12 Monate."
                    addPTag
                  />
                  <BildTextInfo
                    image={AutoBannerAlert}
                    fontSize="38px"
                    title="Monatliche Benachricht&shy;igungen"
                    text="Es lohnt sich, informiert zu bleiben – im wahrsten Sinne des Wortes!
        Erhalte monatliche E-Mail-Benachrichtigungen zur Autobewertung,
        damit du den Wert in Echtzeit verfolgen und zum besten Zeitpunkt für
        dich verkaufen kannst."
                    alt="Screenshot einer E-Mail-Benachrichtigung von Autoeinfachlos zur monatlichen Auto Bewertung, um den Fahrzeugwert in Echtzeit zu verfolgen und den besten Verkaufszeitpunkt zu finden"
                    addPTag
                  />
                </div>

                <HäufigeFragen
                  fragen={fragenZweiData}
                  image={Fragen2}
                  title="Was kann den Wert bei der Autobewertung steigern?"
                  changeOrder
                />
                <HäufigeFragen
                  fragen={fragenEinsData}
                  image={FAQImage}
                  removePaddingTop
                  title="Was kann den Wert bei der Autobewertung negativ beeinflussen?"
                />
                <WertverlustVerfolgen />
                <CarValueBoxes />
                <Ratgeber
                  title="Mehr zum Thema Auto bewerten"
                  autoVerkaufen
                  listenpreisBerechnen
                  fahrgestellnummerPruefen
                  wasistmeinautowert
                  kaputtesAuto
                  wirkaufendeinautoAlternative
                />
                <HäufigeFragen
                  fragen={fragenDreiData}
                  hideImage
                  removePaddingTop
                  title="Häufig gestellte Fragen
      zur Autobewertung"
                />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Autobewerten;
